import { ControlledRadioButton, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { Collapse, ReimbursementChart, SectionTitle, TotalTable } from '@fasstech/middle-design-system';
import useNiveauxGarantiesTarifsPrevTnsGarantiesDecesForm
  from '../hooks/useNiveauxGarantiesTarifsPrevTnsGarantiesDecesForm.js';
import useExtraRules from '../hooks/extra/useExtraRules.js';
import mapOfferNodeOptions from '@@viewHelpers/mapOfferNodeOptions';
import extraMadelin from '../extra/extraMadelin.js';
import { prop } from 'ramda';

const NiveauxGarantiesTarifsPrevTnsGarantiesDecesForm = ({
  form,
  guarantees,
  getMiddleText,
  getMiddleBoolean,
  annualIncome
}) => {
  const {
    ptiaTTCause,
    ptiaAcc,
    anyPTIATrue,
    isPTIARequired,
    deceasedAndPTIACotisation,
    OPTION_TT_CAUSE,
    OPTION_ACC,
    TT_CAUSE_CAP,
    ACC_CAP,
    TT_CAUSE_DEP,
    ACC_DEP,
    TT_CAUSE_MAD,
    ACC_MAD,
    OPTION_ACC_DOUBL_ACC,
    OPTION_ACC_DOUBL_EFFET,
    OPTION_TT_CAUSE_DOUBL_ACC,
    OPTION_TT_CAUSE_DOUBL_EFFET,
    ttCauseHealthInsurances,
    accHealthInsurances,
    ptiaTTCauseReimbursementGraphContent
  } = useNiveauxGarantiesTarifsPrevTnsGarantiesDecesForm({
    form,
    guarantees,
    getMiddleText,
    getMiddleBoolean,
    annualIncome
  });
  const {
    disabledPtiaVersementRenteTTCause,
    disabledPtiaVersementRenteAcc,
    disabledPtiaVersementCapitalAcc
  } = useExtraRules({ form });

  return (
    <Collapse title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_LABEL')}>
      {/*Left column*/}
      <div className="flex-1">
        <SectionTitle>Je souhaite bénéficier de</SectionTitle>
      </div>
      <div className="flex gap-4">
        <div className={'flex flex-col w-2/3'}>
          <ControlledSwitch
            name="guarantees.OPTION_TT_CAUSE.selected"
            label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_TTCAUSE_LABEL')}
            labelClassNames="text-lg"
            displayError={false}
            disabled={!OPTION_TT_CAUSE.editable}
            form={form}
            recommended={OPTION_TT_CAUSE.recommended}
            data-testid="OPTION_TT_CAUSE"
          />
          {OPTION_ACC &&
            getMiddleBoolean(
              'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_ACC_EST_NECESSAIRE'
            ) && (
            <ControlledSwitch
              name="guarantees.OPTION_ACC.selected"
              label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_ACC_LABEL')}
              labelClassNames="text-lg"
              disabled={!OPTION_ACC.editable}
              displayError={false}
              form={form}
              recommended={OPTION_ACC.recommended}
              infoMessage={getMiddleText(
                'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_MESSAGE_INFO'
              )}
              data-testid="OPTION_ACC"
            />
          )}
        </div>
        {anyPTIATrue && <div className="w-1/3 ">
          <div className="w-full">
            <ReimbursementChart
              healthInsurances={ptiaTTCause ? ttCauseHealthInsurances : accHealthInsurances}
              labels={ptiaTTCause ? prop('labelsRO', TT_CAUSE_CAP) : prop('labelsRO', OPTION_ACC)}
              ROs={ptiaTTCause ? prop('RO', TT_CAUSE_CAP) : prop('RO', OPTION_ACC)}
              displayGraph
              rows={ptiaTTCauseReimbursementGraphContent.rows}
              note={ptiaTTCauseReimbursementGraphContent.note}
            />
          </div>
        </div>}
      </div>
      <div className="flex-1">
        {anyPTIATrue && (
          <>
            <hr className="my-5"/>
            <SectionTitle>
              {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_CAPITAL_LABEL')}
            </SectionTitle>

            {ptiaTTCause && (
              <div className="flex flex-col gap-4">
                <ControlledRadioButton
                  withIndicator={false}
                  isMultiline
                  isResponsiveCol
                  name="guarantees.TT_CAUSE_CAP.value"
                  options={mapOfferNodeOptions(TT_CAUSE_CAP)}
                  form={form}
                  rules={isPTIARequired}
                  data-testid="TT_CAUSE_CAP"
                />
              </div>
            )}
            {ptiaAcc && (
              <ControlledRadioButton
                withIndicator={false}
                isMultiline
                isResponsiveCol
                name="guarantees.ACC_CAP.value"
                options={mapOfferNodeOptions(ACC_CAP)}
                form={form}
                rules={isPTIARequired}
                data-testid="ACC_CAP"
              />
            )}
            <p className="mb-4">
              {getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_CAPITAL_LEGENDE')}
            </p>
            {getMiddleBoolean(
              'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_VERSEMENT_EST_NECESSAIRE'
            ) &&
              ptiaTTCause && (
              <>
                <p className="font-bold">
                  {getMiddleText(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_VERSEMENT_LABEL'
                  )}
                </p>
                <ControlledRadioButton
                  withIndicator={false}
                  isMultiline
                  isResponsiveCol
                  form={form}
                  name="guarantees.TT_CAUSE_DEP.value"
                  options={mapOfferNodeOptions(TT_CAUSE_DEP)}
                  data-testid="TT_CAUSE_DEP"
                />
              </>
            )}
            {getMiddleBoolean(
              'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_VERSEMENT_EST_NECESSAIRE'
            ) &&
              ptiaAcc && (
              <>
                <p className="font-bold">
                  {getMiddleText(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_VERSEMENT_LABEL'
                  )}
                </p>
                <ControlledRadioButton
                  withIndicator={false}
                  isMultiline
                  isResponsiveCol
                  form={form}
                  name="guarantees.ACC_DEP.value"
                  options={mapOfferNodeOptions(ACC_DEP)}
                  data-testid="ACC_DEP"
                />
              </>
            )}
            {TT_CAUSE_MAD && ptiaTTCause && (
              <ControlledSwitch
                extraClick={() => extraMadelin(TT_CAUSE_MAD.selected, form)}
                name="guarantees.TT_CAUSE_MAD.selected"
                label={getMiddleText(
                  'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_FISCA_MADELIN_LABEL'
                )}
                labelClassNames="text-lg"
                disabled={!TT_CAUSE_MAD.editable}
                form={form}
                data-testid="TT_CAUSE_MAD"
              />
            )}
            {ACC_MAD && ptiaAcc && (
              <ControlledSwitch
                extraClick={() => extraMadelin(ACC_MAD.selected, form)}
                name="guarantees.ACC_MAD.selected"
                label={getMiddleText(
                  'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_FISCA_MADELIN_LABEL'
                )}
                labelClassNames="text-lg"
                displayError={false}
                disabled={!ACC_MAD.editable}
                form={form}
                data-testid="ACC_MAD"
              />
            )}
            <hr className="my-5"/>
            {getMiddleBoolean(
              'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_EST_NECESSAIRE'
            ) && (
              <>
                <SectionTitle>
                  {getMiddleText(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_LABEL'
                  )}
                </SectionTitle>

                {ptiaAcc &&
                  OPTION_ACC_DOUBL_ACC &&
                  getMiddleBoolean(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_ACC_EST_NECESSAIRE'
                  ) && (
                  <ControlledSwitch
                    name="guarantees.OPTION_ACC_DOUBL_ACC.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_ACC_LABEL'
                    )}
                    labelClassNames="text-lg"
                    disabled={
                      disabledPtiaVersementRenteAcc || !OPTION_ACC_DOUBL_ACC.editable || disabledPtiaVersementCapitalAcc}
                    displayError={false}
                    form={form}
                    recommended={OPTION_ACC_DOUBL_ACC.recommended}
                    infoMessage={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_ACC_MESSAGE_INFO'
                    )}
                    data-testid="OPTION_ACC_DOUBL_ACC"
                  />
                )}

                {ptiaAcc &&
                  OPTION_ACC_DOUBL_EFFET &&
                  getMiddleBoolean(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_EFFET_EST_NECESSAIRE'
                  ) && (
                  <ControlledSwitch
                    name="guarantees.OPTION_ACC_DOUBL_EFFET.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_EFFET_LABEL'
                    )}
                    labelClassNames="text-lg"
                    disabled={disabledPtiaVersementRenteAcc || !OPTION_ACC_DOUBL_EFFET.editable}
                    form={form}
                    displayError={false}
                    recommended={OPTION_ACC_DOUBL_EFFET.recommended}
                    infoMessage={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_EFFET_MESSAGE_INFO'
                    )}
                    data-testid="OPTION_ACC_DOUBL_EFFET"
                  />
                )}

                {ptiaTTCause &&
                  OPTION_TT_CAUSE_DOUBL_ACC &&
                  getMiddleBoolean(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_ACC_EST_NECESSAIRE'
                  ) && (
                  <ControlledSwitch
                    name="guarantees.OPTION_TT_CAUSE_DOUBL_ACC.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_ACC_LABEL'
                    )}
                    labelClassNames="text-lg"
                    disabled={disabledPtiaVersementRenteTTCause || !OPTION_TT_CAUSE_DOUBL_ACC.editable}
                    displayError={false}
                    form={form}
                    recommended={OPTION_TT_CAUSE_DOUBL_ACC.recommended}
                    infoMessage={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_ACC_MESSAGE_INFO'
                    )}
                    data-testid="OPTION_TT_CAUSE_DOUBL_ACC"
                  />
                )}

                {ptiaTTCause &&
                  OPTION_TT_CAUSE_DOUBL_EFFET &&
                  getMiddleBoolean(
                    'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_EFFET_EST_NECESSAIRE'
                  ) && (
                  <ControlledSwitch
                    name="guarantees.OPTION_TT_CAUSE_DOUBL_EFFET.selected"
                    label={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_EFFET_LABEL'
                    )}
                    labelClassNames="text-lg"
                    disabled={disabledPtiaVersementRenteTTCause || !OPTION_TT_CAUSE_DOUBL_EFFET.editable}
                    form={form}
                    displayError={false}
                    recommended={OPTION_TT_CAUSE_DOUBL_EFFET.recommended}
                    infoMessage={getMiddleText(
                      'NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_OPTION_DECES_DOUBL_EFFET_MESSAGE_INFO'
                    )}
                    data-testid="OPTION_TT_CAUSE_DOUBL_EFFET"
                  />
                )}
              </>
            )}
            <TotalTable rows={deceasedAndPTIACotisation}/>
          </>
        )}
      </div>
    </Collapse>
  );
};

export default NiveauxGarantiesTarifsPrevTnsGarantiesDecesForm;
